module.exports = __webpack_public_path__ + "img/fire-flame-04.c95cb200.png";